import { TimeframeSwitcher } from './TimeframeSwitcher'
import './MobileTimeframeRow.css'

/**
 * Row hosting the existing TimeframeSwitcher full-width (D2 point 2).
 * Rendered by MobileHeader as the last child inside its `<header>` — not
 * sticky on its own — so it shares the header's single sticky block
 * instead of pinning itself at a fixed offset that an alarm band or the
 * expanded details/menu panel could occlude. Reuses
 * TimeframeSwitcher/useTimeframe() as-is — no fork, no logic duplication.
 * The 44px segment height comes from a mobile-scoped rule added to
 * TimeframeSwitcher.css itself (scoped to `.timeframe-switcher`, not the
 * shared `.view-toggle` class other panels also use), not from anything in
 * this file.
 */
export function MobileTimeframeRow() {
  return (
    <div className="mobile-timeframe-row">
      <TimeframeSwitcher />
    </div>
  )
}
